export enum LogEventNameEnum {
  LocationEvent = 'LocationEvent',
  EvseEvent = 'EvseEvent',
  SessionEvent = 'SessionEvent',
  CdrEvent = 'CdrEvent',
  ConnectorEvent = 'ConnectorEvent',
  CommandEvent = 'CommandEvent',
}
